/* Rova bug reporter: floating button + modal capturing device/browser diagnostics.
   CSP-safe (external script, addEventListener, script-created <style>). Posts to /bug_report.php. */
(function () {
  if (window.__rovaBug) return;
  window.__rovaBug = true;

  var ERRORS = [];
  function pushErr(kind, msg) {
    ERRORS.push({ t: new Date().toISOString(), kind: kind, msg: String(msg).slice(0, 600) });
    if (ERRORS.length > 50) ERRORS.shift();
  }
  window.addEventListener('error', function (e) {
    pushErr('error', (e.message || 'error') + (e.filename ? ' @ ' + e.filename + ':' + e.lineno : ''));
  });
  window.addEventListener('unhandledrejection', function (e) {
    pushErr('promise', (e.reason && (e.reason.message || e.reason)) || 'unhandledrejection');
  });
  var _ce = console.error;
  console.error = function () { try { pushErr('console', Array.prototype.join.call(arguments, ' ')); } catch (x) {} return _ce.apply(console, arguments); };

  var CSS = [
    '.rvbug-fab{position:fixed;right:16px;bottom:16px;z-index:2147483000;background:linear-gradient(135deg,#f5c518,#b8860b);color:#1a1407;border:none;border-radius:999px;padding:11px 16px;font:700 13.5px -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-shadow:0 8px 26px rgba(245,197,24,.4);cursor:pointer}',
    '.rvbug-ov{position:fixed;inset:0;z-index:2147483001;background:rgba(4,4,6,.62);backdrop-filter:blur(4px);display:none;align-items:center;justify-content:center;padding:18px}',
    '.rvbug-ov.on{display:flex}',
    '.rvbug-card{width:100%;max-width:440px;background:#141216;border:1px solid rgba(212,175,106,.22);border-radius:18px;padding:22px;color:#f4efe3;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-shadow:0 24px 70px rgba(0,0,0,.65)}',
    '.rvbug-card h3{margin:0 0 6px;font-size:18px}',
    '.rvbug-card p{margin:0 0 14px;color:#b3a889;font-size:13px}',
    '.rvbug-card textarea,.rvbug-card input{width:100%;box-sizing:border-box;background:rgba(255,255,255,.05);border:1px solid rgba(212,175,106,.22);border-radius:11px;color:#f4efe3;padding:11px 13px;font-size:14px;font-family:inherit}',
    '.rvbug-card textarea{min-height:96px;resize:vertical;margin-bottom:10px}',
    '.rvbug-meta{color:#8f855f;font-size:11.5px;margin:8px 0 14px;line-height:1.5}',
    '.rvbug-row{display:flex;gap:10px}',
    '.rvbug-btn{flex:1;border:none;border-radius:11px;padding:12px;font:700 14px inherit;cursor:pointer}',
    '.rvbug-btn.p{background:linear-gradient(135deg,#f5c518,#b8860b);color:#1a1407}',
    '.rvbug-btn.g{background:rgba(255,255,255,.06);color:#b3a889;border:1px solid rgba(212,175,106,.22)}',
    '.rvbug-ok{color:#7fdca0;font-size:14px;text-align:center;padding:10px 0}'
  ].join('');

  function el(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstElementChild; }
  function diagnostics() {
    return {
      url: location.href, page_title: document.title, user_agent: navigator.userAgent,
      platform: navigator.platform + ' · ' + (navigator.language || ''),
      screen: window.screen.width + 'x' + window.screen.height + '@' + (window.devicePixelRatio || 1) + 'x',
      viewport: window.innerWidth + 'x' + window.innerHeight, console_errors: ERRORS.slice(),
      extra: { referrer: document.referrer || '', online: navigator.onLine, ts: new Date().toISOString(), scrollY: window.scrollY }
    };
  }

  var FORM = '<h3>Report a bug</h3><p>Tell us what went wrong. Your device, browser and any errors on this page are attached automatically.</p>' +
    '<textarea placeholder="What happened? What did you expect?"></textarea>' +
    '<input type="email" placeholder="Email (optional, if you want a reply)">' +
    '<div class="rvbug-meta"></div>' +
    '<div class="rvbug-row"><button class="rvbug-btn g" data-x>Cancel</button><button class="rvbug-btn p" data-send>Send report</button></div>';

  function mount() {
    var style = document.createElement('style'); style.textContent = CSS; document.head.appendChild(style);
    var ov = el('<div class="rvbug-ov"><div class="rvbug-card"></div></div>');
    document.body.appendChild(ov);
    var card = ov.querySelector('.rvbug-card');
    function close() { ov.classList.remove('on'); }
    function open() {
      // Rebuild the form on every open. On a successful send we overwrite the card
      // with a "Thanks" panel; without this reset, reopening the (reused) modal would
      // show that stale panel with no textarea/Send button and appear permanently broken.
      card.innerHTML = FORM;
      var ta = card.querySelector('textarea'), em = card.querySelector('input'), meta = card.querySelector('.rvbug-meta');
      var d = diagnostics();
      meta.textContent = 'Auto-attached: ' + d.viewport + ' viewport · ' + d.screen + ' screen · ' +
        (d.console_errors.length ? d.console_errors.length + ' console error(s)' : 'no console errors') + ' · this page';
      card.querySelector('[data-send]').addEventListener('click', function () {
        var desc = ta.value.trim();
        if (desc.length < 5) { ta.focus(); ta.style.borderColor = '#e0574e'; return; }
        var body = diagnostics(); body.description = desc; body.email = em.value.trim();
        fetch('/bug_report.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.text(); }).then(function () {
            card.innerHTML = '<h3>Thanks 🙌</h3><div class="rvbug-ok">Your report was sent. We read every one.</div>' +
              '<div class="rvbug-row"><button class="rvbug-btn p" data-x>Close</button></div>';
            card.querySelector('[data-x]').addEventListener('click', close);
          }).catch(function () { meta.textContent = 'Could not send right now. Please try again.'; });
      });
      ov.classList.add('on'); ta.focus();
    }
    window.rovaReportBug = open;
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-report-bug]');
      if (t) { e.preventDefault(); open(); }
    });
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.hasAttribute('data-x')) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();

/* ---- /report-issue attachment picker ------------------------------------
   The screenshot / screen-recording field on the public report form. Lives here
   rather than in app.js for two reasons: app.js is edited by several people at once
   and this is a self-contained feature, and bugreport.js is already loaded on every
   page (View::render emits both), so it costs no extra request.

   app.js already submits that form as `new FormData(form)`, which carries a file part
   with no change at all -- so this file is purely the human half: name the chosen file,
   state its weight, and refuse an over-cap one BEFORE it is uploaded rather than after
   a member on a phone has pushed 40 MB up a mobile uplink to be told no.

   IT REFUSES BY CLEARING THE INPUT, deliberately, instead of intercepting the submit.
   app.js registers its submit handler first and calls preventDefault + fetch inside it;
   racing that would mean a capture-phase listener on document and a stopImmediatePropagation,
   i.e. this file reaching into another file's event. An empty input cannot be submitted,
   so the simple version is also the one that cannot break the plain report path.

   None of this is a security control. Every cap and every type test is enforced again,
   from the bytes, in FeedbackFiles::accept(). */
(function () {
  var card = document.getElementById('bug-card');
  if (!card) return;
  var input = card.querySelector('#bug-file');
  if (!input) return;
  var note = card.querySelector('.bug-file-pick');
  if (!note) return;

  var MAX_IMG = parseInt(input.getAttribute('data-max-img'), 10) || 8388608;
  var MAX_VID = parseInt(input.getAttribute('data-max-vid'), 10) || 26214400;
  var OK = {
    'image/jpeg': 1, 'image/png': 1, 'image/webp': 1, 'image/gif': 1,
    'video/mp4': 1, 'video/quicktime': 1, 'video/webm': 1
  };

  function mb(n) { return (n / 1048576).toFixed(n < 10485760 ? 1 : 0) + ' MB'; }
  function show(html, bad) {
    note.innerHTML = html;
    note.style.color = bad ? '#e0574e' : '';
    note.hidden = false;
  }
  function clear() { input.value = ''; }

  input.addEventListener('change', function () {
    var f = input.files && input.files[0];
    if (!f) { note.hidden = true; return; }

    // The browser's `type` is the CLIENT's claim and is routinely empty on Android.
    // Treat an unknown type as "let the server decide" rather than refusing here --
    // a false refusal in the browser is invisible to us, while a bad file server-side
    // is refused by content sniffing anyway.
    var t = (f.type || '').toLowerCase();
    if (t && !OK[t]) {
      clear();
      show('That file type isn’t supported. Send a JPG, PNG, WEBP or GIF screenshot, or an MP4, MOV or WEBM recording.', true);
      return;
    }
    var isVid = t.indexOf('video/') === 0;
    var cap = isVid ? MAX_VID : (t ? MAX_IMG : MAX_VID);
    if (f.size > cap) {
      clear();
      show('That file is ' + mb(f.size) + ', the limit is ' + mb(cap) +
           (isVid ? '. Try a shorter clip (10–20 seconds is usually plenty).' : '.'), true);
      return;
    }
    // Neutral clip when the browser told us nothing (Android often does): claiming
    // "screenshot" for a file we have not identified would be a small lie on screen.
    show((isVid ? '🎬 ' : (t ? '🖼️ ' : '📎 ')) +
         (f.name || 'attachment').replace(/[<>&]/g, '') + ' · ' + mb(f.size) +
         ' · <a href="#" class="bug-file-x">remove</a>', false);
  });

  note.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('.bug-file-x');
    if (!x) return;
    e.preventDefault();
    clear();
    note.hidden = true;
  });
})();
